import { HeaderImageColumn } from '../image-column'
import { HouseOfGassanContent } from '@lib/kontent/navigation-helpers/get-house-of-gassan-content'
import { FC } from 'react'

type HeaderMobileNavHouseOfGassanProps = {
  columns: HouseOfGassanContent
}

export const HeaderMobileNavHouseOfGassan: FC<HeaderMobileNavHouseOfGassanProps> = ({
  columns,
}) => {
  return (
    <>
      {columns.map((column, key) => (
        <>
          {key > 0 && <div className="h-10 md:p-16" />}
          <HeaderImageColumn {...column} key={key} />
        </>
      ))}
    </>
  )
}
